import React from "react";
import { animated, useSpring } from "react-spring";
import styled, { withTheme } from "styled-components";
import Paper from "../../ui-library/Paper/Paper";

const StyledPaper = styled(Paper)`
  -webkit-box-shadow: 0 0.2rem 1rem rgba(0, 0, 0, 0.1) !important;
  -moz-box-shadow: 0 0.2rem 1rem rgba(0, 0, 0, 0.1) !important;
  box-shadow: 0 0.2rem 1rem rgba(0, 0, 0, 0.1) !important;
  &.card {
    border-radius: 0.6rem;
  }
`;

const StyledAnimatedDiv = styled(animated.div)`
  display: inline;
  width: 60px;
  height: 60px;
  font-size: 30px;
  line-height: 60px;
  background-color: ${(props) => props?.theme?.yellowGreen};
  position: absolute;
  margin-left: -70px;
  margin-top: 40px;
  color: #fff;
  border-radius: 100%;

  @media only screen and (max-width: 760px),
    (min-device-width: 768px) and (max-device-width: 1024px) {
    display: none;
  }
`;

const CardIcon = (props) => {
  const { className } = props;

  const animatedProps = useSpring({
    width: 80,
    height: 80,
    scale: 1,
    fontSize: 50,
    from: {
      scale: 0.25,
    },
    config: {
      mass: 1,
      tension: 400,
      friction: 10,
    },
  });

  return (
    <StyledAnimatedDiv
      className="text-center"
      style={animatedProps}
      data-testid={props["data-testid"]}
    >
      <i
        className={`${className}`}
        style={{ marginTop: "0.90rem" }}
        data-testid={props["data-testid"] + "-i"}
      />
    </StyledAnimatedDiv>
  );
};

const CardBody = styled.div`
  &.card-body {
    padding: 0.5rem 2rem 2rem 2rem;
  }
  @media only screen and (max-width: 760px),
    (min-device-width: 768px) and (max-device-width: 1024px) {
    padding: 0 !important;
  }
`;

const ProfileCard = (props) => {
  const {
    showIcon = true,
    iconClassName,
    title,
    children,
    cardHeader,
    ultraShadow,
    addPadding = false,
    image = "",
    hasSeparator,
  } = props;
  return (
    <StyledPaper
      header={title}
      ultraShadow={ultraShadow}
      cardHeader={cardHeader}
      className="card mb-4 profile-card h-100"
      image={image}
      hasSeparator={hasSeparator}
    >
      {showIcon && (
        <CardIcon className={iconClassName} data-testid="test-card-icon" />
      )}
      <CardBody className={`${addPadding ? "card-body" : ""} smallscroll`}>
        {children}
      </CardBody>
    </StyledPaper>
  );
};

export default withTheme(ProfileCard);
